import React from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { Grid, Typography } from '@material-ui/core';


const useStyles = makeStyles(theme => ({
  root: {
    backgroundColor: theme.palette.background.paper,
  },
  description: {
    paddingTop: '2vh',
    fontSize: '16px',
    color: '#4e4e4e',
    textAlign: 'center',
    marginRight: '7vw',
    marginLeft: '7vw'
  },
  title: {
    fontWeight: 700,
    textAlign: 'center',
    fontSize: 32,
    marginTop: '8vh',
    lineHeight: 'normal'
  }
}));

const Header = props => {
  const { className, ...rest } = props;
  const classes = useStyles();
  return (
    <div
      {...rest}
      className={clsx(classes.root, className)}
    >
      <Grid
        container
        justify="center"
        style={{ marginTop: '-1%' }}
      >
        <Grid item>
          <Typography className={classes.title}>Quick Codes</Typography>
          <Typography className={classes.description} >...</Typography>
        </Grid>
      </Grid>
      <hr style={{ borderColor: '#E8E8E8', borderTop: 'none', borderLeft: 'none', borderRight: 'none', paddingTop: '3vh' }} />
    </div>
  );
};


export default Header;